import React from 'react';

// MUI
import { Box } from '@mui/material';

// Styles
import './styles.scss';
import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';

/**
 * OLCBaseModal
 * - Provides standardized header and footer buttons consistent with system styling
 * - Renders children in the body
 * - Edit-friendly via primary button labeling and optional subtitle
 */
const OLCBaseModal = ({
  open,
  onClose,
  onSubmit,
  title,
  subTitle,
  children,
  primaryText,
  secondaryText = 'Cancel',
  loading = false,
  width = 640,
  disablePrimary = false,
  disableScrollLock = false,
  paperClassName = '',
}) => {
  const resolvedPrimaryText = primaryText || 'Save';
  const footer = (
    <>
      <OlcButton variant="secondary" onClick={onClose}>
        {secondaryText}
      </OlcButton>
      <OlcButton variant="primary" disabled={loading || disablePrimary} onClick={onSubmit}>
        {resolvedPrimaryText}
      </OlcButton>
    </>
  );

  return (
    <OlcFormModal
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subTitle}
      className={`olcBaseModalWrapper ${paperClassName}`}
      contentClassName="olcBaseModalContent"
      footerClassName="olcBaseFooter"
      footer={footer}
      dialogProps={{
        maxWidth: false,
        disableScrollLock,
        PaperProps: {
          style: { '--olc-form-modal-max-width': `${width}px` },
        },
      }}
    >
      <Box className="olcBaseBody">{children}</Box>
    </OlcFormModal>
  );
};

export default OLCBaseModal;
